import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { map, Observable } from 'rxjs';

import { APOLLO_CLIENT_NAMES } from '@customer-portal/shared/constants';
import {
  apolloThrowIfNotSuccess,
  getQueryRootFieldName,
} from '@customer-portal/shared/helpers/custom-operators';

import { ActionsListDto } from '../../dtos';
import { ACTIONS_LIST_QUERY } from '../../graphql';
import { UPDATE_ACTION_READ_STATUS } from '../../graphql/mutations';

@Injectable({ providedIn: 'root' })
export class ActionsListService {
  private clientName = APOLLO_CLIENT_NAMES.notification;

  constructor(private readonly apollo: Apollo) {}

  getActionsList(): Observable<ActionsListDto> {
    const fieldName = getQueryRootFieldName(ACTIONS_LIST_QUERY) || 'actions';

    return this.apollo
      .use(this.clientName)
      .query({
        query: ACTIONS_LIST_QUERY,
        fetchPolicy: 'no-cache',
      })
      .pipe(
        apolloThrowIfNotSuccess(fieldName),
        map((results: any) => results?.data?.actions),
      );
  }

  updateAction(id: number): Observable<boolean> {
    const fieldName =
      getQueryRootFieldName(UPDATE_ACTION_READ_STATUS) || 'actions';

    return this.apollo
      .use(this.clientName)
      .mutate({
        mutation: UPDATE_ACTION_READ_STATUS,
        variables: {
          actionId: id,
        },
      })
      .pipe(
        apolloThrowIfNotSuccess(fieldName),
        map(
          (results: any) =>
            results?.data?.updateSurveyActionStatus?.data?.isSuccess ?? false,
        ),
      );
  }
}
